export const useToast = (props) => {
  const { hasKey, ...rest } = props;

  const rps = {
    role: 'alert',
  };

  return {
    ...rps,
    ...rest,
  };
};
